import CloudOff from "@mui/icons-material/CloudOff";
import { useTenantTranslation } from "hooks/formatters";
import { ConnectionDialog } from "./ConnectionDialog";
import { RootState } from "src/store/store";
import { useAppSelector } from "src/store/store";

/**
 * This dialog is used to display a message to the user when the app is offline.
 * It is used to inform the user that the app is offline and that they should check their internet connection.
 * It is also used to reload the app when the user is offline and comes back online.
 * @returns A dialog with a message to the user when the app is offline.
 */
export const ErrorDetectorDialog = () => {
  const { t } = useTenantTranslation();
  const lastErrorTimestamp = useAppSelector(
    (state: RootState) => state.connection.lastErrorTimestamp
  );

  if (!lastErrorTimestamp) {
    return null;
  }

  return (
    <ConnectionDialog
      content={{
        icon: <CloudOff fontSize="large" />,
        title: t("cantConnectToServer"),
        severity: "warning" as const,
        bgcolor: "warning.main",
        color: "warning.contrastText",
        message: t("serverCurrentlyUnavailable"),
        subtitle: t("pleaseWaitOrContactSupport"),
        buttonBgColor: "warning.contrastText",
        buttonTextColor: "warning.main",
      }}
    />
  );
};
